













import Vue, { PropType } from 'vue';
// import { BrandData } from '@/modules/exhibitor/brand';
// import { Story } from '@/modules/exhibitor/story';
import {
  Brand,
} from 'mostra';
// import { v4 } from 'uuid';
//
// const generateListKey = () => v4();
//
// const {
//   createStoryTitle,
//   createStoryDescription,
//   createStoryImage,
//   createStoryVideo,
// } = story;
//
// type BrandStoryItem = {
//   id: string,
//   story: Story,
// }
//
// const addButtonSelectMenu = [
//   { value: 'StoryTitle', text: 'タイトル・見出し' },
//   { value: 'StoryDescription', text: '本文' },
//   { value: 'StoryImage', text: '画像' },
//   { value: 'StoryVideo', text: 'YouTube動画' },
// ];

export default Vue.extend({
  name: 'GBrandStoryForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    brand: {
      type: Object as PropType<Brand>,
    },
    // onAddStory: {
    //   type: Function as PropType<Function>,
    // },
    // onDeleteStory: {
    //   type: Function as PropType<Function>,
    // },
    // onSwitchPosition: {
    //   type: Function as PropType<Function>,
    // },
  },
  // data() {
  //   return {
  //     addButtonSelectMenu: addButtonSelectMenu,
  //   };
  // },
  // computed: {
  //   stories(): BrandStoryItem[] {
  //     return this.brand.stories.map((story: Story) => (
  //       {
  //         id: generateListKey(),
  //         story: story,
  //       }
  //     ));
  //   },
  // },
  // methods: {
  //   onAddStory(val: string) {
  //     if (!this.brand) return;
  //     let newStory;
  //     switch (val) {
  //       case 'StoryTitle':
  //         newStory = createStoryTitle();
  //         break;
  //       case 'StoryDescription':
  //         newStory = createStoryDescription();
  //         break;
  //       case 'StoryImage':
  //         newStory = createStoryImage();
  //         break;
  //       case 'StoryVideo':
  //         newStory = createStoryVideo();
  //         break;
  //       default:
  //     }
  //     if (!newStory) return;
  //     this.brand.data.stories = [...this.brand.data.stories, newStory];
  //   },
  //   onDeleteStory(targetIndex: number) {
  //     return () => {
  //       if (!this.brand) return;
  //       this.brand.data.stories.splice(targetIndex, 1);
  //     };
  //   },
  //   onSwitchStoryPosition(mode: string, targetIndex: number) {
  //     return () => {
  //       if (!this.brand) return;
  //       let swapTargetIndex = 0;
  //       if (mode === 'up') {
  //         if (targetIndex === 0) {
  //           return;
  //         }
  //         swapTargetIndex = targetIndex - 1;
  //       }
  //       if (mode === 'down') {
  //         if (targetIndex === this.brand.data.stories.length - 1) {
  //           return;
  //         }
  //         swapTargetIndex = targetIndex + 1;
  //       }
  //       const copiedStoies = [...this.brand.data.stories];
  //       copiedStoies[swapTargetIndex] = this.brand.data.stories[targetIndex];
  //       copiedStoies[targetIndex] = this.brand.data.stories[swapTargetIndex];
  //       this.brand.data.stories = copiedStoies;
  //     };
  //   },
  // },
});
